const entity = {
    create_failed: 'Nie udało się utworzyć {{name}}.',
    not_exists: '{{name}} nie istnieje.',
    not_exists_with_id: '{{name}} o identyfikatorze `{{id}}` nie istnieje.',
    not_found: 'Zasób nie istnieje.',
};
export default entity;
